// extracted by mini-css-extract-plugin
export default {"pieChart-cont":"AgeGraph_pieChart-cont__FvsaC","stacked_graph":"AgeGraph_stacked_graph__R0rur","stacked_graph_scrollable":"AgeGraph_stacked_graph_scrollable__CN4tp"};